import { useState } from 'react';
import ButtonLoader from '../ButtonLoader';

const EmergencyContact = ({ labourer, isLoading, onSubmit }) => {
  const [fullName, setFullName] = useState(labourer?.emergencyContact?.fullName || '');
  const [relationship, setRelationship] = useState(labourer?.emergencyContact?.relationship || '');
  const [phoneNumber, setPhoneNumber] = useState(labourer?.emergencyContact?.phoneNumber || '');

  const handleSubmit = (e) => {
    e.preventDefault();

    onSubmit({
      fullName,
      relationship,
      phoneNumber
    });
  }

  return (
    <>
      <form
        onSubmit={handleSubmit}
        className='flex flex-col gap-4'
      >
        <label className='flex flex-col gap-1'>
          <span>Full name</span>

          <input
            type="text"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            required
          />
        </label>

        <label className='flex flex-col gap-1'>
          <span>Emergency contact relationship</span>
          <span className='text-xs'>(e.g., spouse, sibling)</span>

          <input
            type="text"
            value={relationship}
            onChange={(e) => setRelationship(e.target.value)}
            required
          />
        </label>

        <label className='flex flex-col gap-1'>
          <span>Emergency contact phone number</span>
          <input
            type="tel"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            required
          />
        </label>

        <div className='flex'>
          <button
            type="submit"
            className='bg-ase-blue h-[48px] px-4 font-semibold text-white rounded-md'
          >
            {isLoading ? <ButtonLoader /> : 'Update'}
          </button>
        </div>
      </form>
    </>
  )
}

export default EmergencyContact;
